/**
 * @generated SignedSource<<be475960207680f0dbc3324fd3692970>>
 * @relayHash 8815c4d7624ba323098e4ae6329cffb6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a58bead1c2be0cc27b64f848803af9b2734e3b57f086f23b0237573f395838e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PageRestrictionsContextQuery$variables = {
  contentId: string;
  includeAncestors: boolean;
  status?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type PageRestrictionsContextQuery$data = {
  readonly singleContent: {
    readonly ancestors?: ReadonlyArray<{
      readonly hasRestrictions: boolean;
      readonly id: string | null | undefined;
      readonly links: {
        readonly webui: string | null | undefined;
      } | null | undefined;
      readonly title: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly hasInheritedRestrictions: boolean;
    readonly hasRestrictions: boolean;
    readonly hasViewRestrictions: boolean;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type PageRestrictionsContextQuery = {
  response: PageRestrictionsContextQuery$data;
  variables: PageRestrictionsContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAncestors"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
      },
      {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
      },
      (v4/*: any*/),
      {
        "condition": "includeAncestors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "title"
              },
              (v4/*: any*/),
              {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "webui"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageRestrictionsContextQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageRestrictionsContextQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "8815c4d7624ba323098e4ae6329cffb6",
    "id": "0a58bead1c2be0cc27b64f848803af9b2734e3b57f086f23b0237573f395838e",
    "metadata": {},
    "name": "PageRestrictionsContextQuery",
    "operationKind": "query",
    "text": "query PageRestrictionsContextQuery($contentId:ID!,$status:[String],$includeAncestors:Boolean!){singleContent(id:$contentId,status:$status){id,hasInheritedRestrictions,hasViewRestrictions,hasRestrictions,ancestors@include(if:$includeAncestors){id,title,hasRestrictions,links{webui}}}}"
  }
};
})();

(node as any).hash = "f929d3439daa7ff3d3d7211e71053f2c";

export default node;
